/** @format */

import Messages from "./../../library/Messages";
import Copy from "./../../components/Copy";

export default class Quotes {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Quotes();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on("change", ".js-on-change-update-quote-item-quantity", function () {
			self.updateItemQuantity(
				$(this).data("item"),
				$(this).val(),
				$(this).parents(".basket-item")
			);
		});

		$(document).on("click", ".js-remove-quote-item", function (e) {
			e.preventDefault();
			self.removeItem($(this).data("item"));
		});

		$(document).on("change", ".js-quote-item-checkbox", function (e) {
			self.updateQuoteTotalBasedOnCheckedItems($(this).parents(".basket-item"));
		});

		$(document).on("click", ".js-remove-quote-bundle-item", function (e) {
			e.preventDefault();
			self.removeBundleItems($(this).data("bundle-id"), $(this).data("bundle-ids"));
		});

		$(document).on("click", ".js-share-quote", function (e) {
			e.preventDefault();
			self.shareQuote($(this));
		});

		$(document).on("click", ".js-download-quote", function (e) {
			e.preventDefault();
			self.downloadQuote($(this));
		});

		$(document).on("click", ".js-share-quote-basket", function (e) {
			e.preventDefault();
			self.shareQuoteBasket();
		});

		$(document).on("click", ".js-share-url-btn", function (e) {
			e.preventDefault();
			self.copyBtn();
		});
	}

	updateItemQuantity(id, quantity, $item) {
		const self = this;

		oc.progressBar.show();

		// Get an array of all checked item id's
		const checkedItemIdsArr = self.getAllCheckedItemIds();

		oc.ajax("quote::onUpdateQuantity", {
			data: {
				id: id,
				quantity: quantity,
			},
			update: { "quote/default": ".js-quote" },
			success: function (data, responseCode, xhr) {
				// this.success(data, responseCode, xhr);

				self.setQuoteItemCheckedState(checkedItemIdsArr);

				self.updateQuoteTotalBasedOnCheckedItems($item, checkedItemIdsArr);

				Messages.success("Quantity successfully updated");

				oc.progressBar.hide();
			},
			error: function (data, responseCode, xhr) {
				oc.progressBar.hide();

				Messages.error("Quantity could not be updated");
			},
		});
	}

	removeItem(id) {
		const self = this;

		oc.progressBar.show();

		oc.ajax("quote::onRemoveItem", {
			data: { id: id },
			update: { "quote/default": ".js-quote" },
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);
				oc.progressBar.hide();

				Messages.success("Item successfully removed");
			},
			error: function (data, responseCode, xhr) {
				oc.progressBar.hide();

				Messages.error("Item could not be removed");
			},
		});
	}

	removeBundleItems(bundleId, bundle_ids) {
		const self = this;

		oc.progressBar.show();

		oc.ajax("quote::onRemoveBundleItem", {
			data: {
				bundle_id: bundleId,
				bundle_ids: bundle_ids,
			},
			update: { "quote/default": ".js-quote" },
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);
				oc.progressBar.hide();

				Messages.success("Item successfully removed");
			},
			error: function (data, responseCode, xhr) {
				oc.progressBar.hide();

				Messages.error("Item could not be removed");
			},
		});
	}

	shareQuote(button) {
		const self = this;

		oc.progressBar.show();

		oc.ajax("quote::onShareQuote", {
			data: {
				quote_id: button.data("quote-id"),
			},
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);
				oc.progressBar.hide();

				Copy.clipboardCopy(data.result);

				Messages.success("Copied to clipboard.");
			},
			error: function (data, responseCode, xhr) {
				oc.progressBar.hide();

				Messages.error("Something went wrong, please try again.");
			},
		});
	}

	downloadQuote(button) {
		const downloadUrl = button.attr("href") || `/account/quote-download/${button.data("quote-id")}`;

		if (!downloadUrl) {
			Messages.error("Quote could not be downloaded.");
			return;
		}

		window.location.assign(downloadUrl);
	}

	shareQuoteBasket() {
		const self = this;

		oc.progressBar.show();

		oc.ajax("shopBasket::onShareQuote", {
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);
				oc.progressBar.hide();

				$(".js-share-slide").slideDown(300);
				$("#js-share-url").text(data.result);
			},
			error: function (data, responseCode, xhr) {
				oc.progressBar.hide();

				Messages.error("Something went wrong, please try again.");
			},
		});
	}

	updateQuoteTotalBasedOnCheckedItems($item, checkedItemIds) {
		const self = this;

		if (!checkedItemIds) {
			checkedItemIds = self.getAllCheckedItemIds($item);
		}

		const quoteId = self.getQuoteId(),
			groupId = $item.data("group-id");

		oc.progressBar.show();

		oc.ajax("quote::onChangeCheckboxUpdateTotal", {
			data: {
				quoteId: quoteId,
				checkedItemIds: checkedItemIds,
			},
			success: function (data, responseCode, xhr) {
				oc.progressBar.hide();

				const quoteTotal = data.total;

				console.log(`quoteTotal ${quoteTotal}`);

				$(".js-quote-total .js-price-value").text(quoteTotal);

				// Access the personalisations object for the specific product ID (groupId)
				const personalisationsObj = data.personalisations[groupId].personalisations;

				self.updatePersonalisationRow(personalisationsObj, $item);
			},
			error: function () {
				oc.progressBar.hide();
			},
		});
	}

	getAllCheckedItemIds() {
		const checkedItemsIdsArr = $(".js-quote-item-checkbox:checked")
			.map(function () {
				if ($(this).data("items")) {
					return $(this).data("items").split(",");
				} else {
					return $(this).data("item");
				}
			})
			.get();

		return checkedItemsIdsArr;
	}

	setQuoteItemCheckedState(checkedItemIdsArr) {
		// Iterate over each checkbox with the class .js-quote-item-checkbox
		$(".js-quote-item-checkbox").each(function () {
			const itemId = $(this).data("item");

			// Check if itemId is in checkedItemIdsArr
			if (checkedItemIdsArr.includes(itemId)) {
				$(this).prop("checked", true); // Set to checked
			} else {
				$(this).prop("checked", false); // Set to unchecked
			}
		});
	}

	getQuoteId() {
		const quoteId = $(".js-quote").find('input[name="quote_id"]').val();

		return quoteId;
	}

	getChangedItemQuoteItemId($item) {
		const quoteItemId = $item.find('input[name*="quote_item_id"]').val();

		return quoteItemId;
	}

	updatePersonalisationRow(personalisations, $item) {
		const self = this;

		const personalisationsQty =
			personalisations && personalisations.quantity ? personalisations.quantity : 0;

		const personalisationsTotal =
			personalisations && personalisations.total ? personalisations.total : 0;

		console.log(`Peronalisations total: ${personalisationsTotal}`);
		console.log(`Peronalisations qty total: ${personalisationsQty}`);

		const $personalisationRow = $item.find(".js-personalisation-row");

		if (Number(personalisationsTotal)) {
			$item.find(".js-personalisation-qty").text(personalisationsQty);
			$personalisationRow.find(".js-price-value").text(personalisationsTotal);
			$personalisationRow.show();
		} else {
			$personalisationRow.hide();
		}

		return self;
	}

	copyBtn() {
		navigator.clipboard.writeText($("#js-share-url").text());

		Messages.success("Copied to clipboard.");
	}
}
